import { useState } from 'react';
import { Calendar, List, Search } from 'lucide-react';
import CalendarioCirugias from '../../components/cirugias/CalendarioCirugias';
import CirugiasPendientes from '../../components/cirugias/CirugiasPendientes';
import BusquedaCirugias from '../../components/cirugias/BusquedaCirugias';

type Tab = 'calendario' | 'pendientes' | 'busqueda';

export default function CirugiasPage() {
  const [activeTab, setActiveTab] = useState<Tab>('calendario');

  const tabs = [
    { id: 'calendario' as Tab, label: 'Calendario', icon: Calendar },
    { id: 'pendientes' as Tab, label: 'Cirugías Pendientes', icon: List },
    { id: 'busqueda' as Tab, label: 'Búsqueda', icon: Search },
  ];

  return (
    <div>
      {/* Header */}
        <div className="mb-3 flex items-center gap-3">
          <h1 className="text-lg font-bold text-gray-900">Control de Cirugías</h1>
          <span className="text-gray-400 text-sm">·</span>
          <p className="text-gray-500 text-sm">Gestión de procedimientos quirúrgicos</p>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-lg shadow-sm mb-4">
          <div className="border-b border-gray-200">
            <nav className="flex -mb-px">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`
                      flex items-center gap-2 px-6 py-4 border-b-2 font-medium text-sm
                      transition-colors duration-200
                      ${
                        activeTab === tab.id
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }
                    `}
                  >
                    <Icon className="w-5 h-5" />
                    {tab.label}
                  </button>
                );
              })}
            </nav>
          </div>

          {/* Tab Content */}
          <div className="p-6">
            {activeTab === 'calendario' && <CalendarioCirugias />}
            {activeTab === 'pendientes' && <CirugiasPendientes />}
            {activeTab === 'busqueda' && <BusquedaCirugias />}
          </div>
        </div>
    </div>
  );
}
